import { CSSProperties } from "react";
import { PdfPreviewContent } from "../PdfPreviewContent";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { monthsTranslation } from "../../utils/months";
import { formatDateForInput } from "../../utils/dateFormatter";
import { BASE_URL, UPLOAD_IMAGES } from "../../utils/constants";
import { useIES } from "../../hooks/useIES";
interface ExtendedCSSProperties extends CSSProperties {
  "@media print"?: CSSProperties;
}

export const Receipt = () => {
  const currentDate = new Date().toLocaleDateString('pt-PT');
  const loggedUserData = useSelector((state: RootState) => state.login.userData)
  const userData = useSelector((state: RootState) => state.user)
  const studentData = useSelector((state: RootState) => state.student)
  const studentDebtData = useSelector((state: RootState) => state.studentDebt)
  const transactionData = useSelector((state: RootState) => state.paymentTransaction)
  const { IES, isLoading } = useIES();
  const styles: { [key: string]: ExtendedCSSProperties } = {
    container: {
      fontFamily: "Arial, sans-serif",
      padding: "0px",
      // border: "1px solid #3cb371",
      lineHeight: "1.5",
      fontSize: "10px",
    },
    logo: {
      width: "70px",
    },
    informationSection: {
      marginTop: "30px",
      display: "flex",
      justifyContent: "space-between",
    },
    universityInformation: {
      width: "50%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",

    },
    invoiceInformation: {
      width: "50%",
      border: "1px solid #3cb371",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      borderRadius: "10px",
      overflow: "hidden",
    },
    table: {
      borderCollapse: "collapse",
      width: "100%",
      borderRadius: "10px",
      overflow: "hidden",
    },
    th: {
      backgroundColor: "#3cb371",
      color: "white",
      textAlign: "center",

      borderRadius: "10px",
    },
    tr: {
      verticalAlign: "baseline",
    },
    studentInformation: {

      border: "1px solid #3cb371",
      marginTop: "20px",
      borderRadius: "10px",
      overflow: "hidden",
    },
    labelCell: {
      padding: "0px 8px 0px 8px",
      // fontWeight: "bold",
      textAlign: "left",
    },
    valueCell: {
      textAlign: "left",
    },
    valueCell1: {
      textAlign: "right",
      paddingRight: "8px",
    },
    itemTable: {
      marginTop: "20px",
      borderRadius: "10px",
      overflow: "hidden",
    },
    itemHeader: {
      backgroundColor: "#3cb371",
      color: "white",
      textAlign: "center",
    },
    itemHeader1: {
      backgroundColor: "#3cb371",
      color: "white",
      textAlign: "center",
      borderBottomLeftRadius: '10px',
    },
    itemHeader2: {
      backgroundColor: "#3cb371",
      color: "white",
      textAlign: "center",
      borderBottomRightRadius: '10px',
    },
    itemCell: {
      textAlign: "center",
      padding: "8px",
    },
    description: {
      marginTop: "10px",
      fontWeight: "bold",
      textAlign: "left",
    },
    paymentInfoSection: {
      marginTop: "10px",
      display: "flex",
      justifyContent: "space-between",
    },
    paymentTable70: {
      border: "1px solid #3cb371",
      borderRadius: "10px",
      overflow: "hidden",
      marginTop: "10px",
      width: "60%",
      marginRight: "8px"
    },
    paymentTable701: {
      border: "1px solid #3cb371",
      borderRadius: "16px",
      overflow: "hidden",
      marginTop: "10px",
      width: "60%",
      marginRight: "8px",
      visibility: 'hidden',
    },
    paymentTable30: {
      border: "1px solid #3cb371",
      borderRadius: "10px",
      overflow: "hidden",
      marginTop: "10px",
      width: "40%",
      backgroundColor: "#3cb371",
      color: "white",
    },
    paymentTable301: {
      border: "1px solid #3cb371",
      borderRadius: "16px",
      overflow: "hidden",
      width: "40%",
    },
    paymentHeader: {
      backgroundColor: "white",
      textAlign: "center",
    },
    totalRow: {
      border: "1px solid #3cb371",
      borderRadius: "10px",
      marginTop: "10px",
      padding: "10px",
      textAlign: "right",
      backgroundColor: "white",
      width: "26%",
      justifySelf: 'end'
    },
  };
  const total = transactionData.transactions?.reduce((accumulator, current) => {
    return accumulator + (current?.amountPaid || 0);
  }, 0);

  return (
    <PdfPreviewContent>
      <div style={styles.container}>
        <img 
         src={`${IES.LOGO}`}
         alt="Logo da instituição de ensino superior" style={styles.logo} />

        <div style={styles.informationSection}>
          <div style={styles.universityInformation}>
            <table>
              <tr style={styles.tr}>
                <td>Endereço:</td>
                <td>{IES.CITY} {IES.COUNTRY}</td>
              </tr>
              <tr style={styles.tr}>
                <td>NUIT:</td>
                <td>{IES.NUIT}</td>
              </tr>
              <tr style={styles.tr}>
                <td>Unidade:</td>
                <td>Direcção de Administração Financeira</td>
              </tr>
              <tr style={styles.tr}>
                <td>Telefone:</td>
                <td>{IES.PHONE_NUMBER}</td>
              </tr>
              <tr style={styles.tr}>
                <td>E-mail:</td>
                <td>{IES.EMAIL}</td>
              </tr>
            </table>
          </div>

          <div style={styles.invoiceInformation}>

            <table style={styles.table}>
              <thead>
                <tr style={styles.tr}>
                  <th colSpan={4} style={styles.th}>
                    Recibo Número: {`1/${studentDebtData?.code}`}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr style={styles.tr}>
                  <td style={styles.labelCell}>Serviço:</td>
                  <td style={styles.valueCell}>
                    {studentData?.student?.course ?? studentData?.course ?? 'N/D'}
                  </td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.labelCell}>Semestre:</td>
                  <td style={styles.valueCell}>{studentData?.semester}</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.labelCell}>Factura</td>
                  <td style={styles.valueCell}>{studentDebtData?.code ?? 'N/D'}</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.labelCell}>Data</td>
                  <td style={styles.valueCell}>{studentDebtData?.paidDate ? formatDateForInput(studentDebtData.paidDate) : currentDate}</td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>

        <div style={styles.studentInformation}>
          <table style={styles.table}>
            <thead>
              <tr style={styles.tr}>
                <th colSpan={4} style={styles.th}>
                  Estudante
                </th>
              </tr>
            </thead>
            <tbody>
              <tr style={styles.tr}>
                <td style={styles.labelCell}>Nome:</td>
                <td style={styles.valueCell}>{studentDebtData?.fullname}</td>
                <td style={styles.labelCell}>Número:</td>
                <td style={styles.valueCell}>{studentData?.schoolCode ?? studentDebtData?.studentCode ?? userData?.userName}</td>
              </tr>
              <tr style={styles.tr}>
                <td style={styles.labelCell}>NUIT:</td>
                <td style={styles.valueCell}>{userData?.nuit}</td>
                <td style={styles.labelCell}>Telefone:</td>
                <td style={styles.valueCell}>{userData?.phoneNumber}</td>
              </tr>
              <tr style={styles.tr}>
                <td style={styles.labelCell}>Endereço:</td>
                <td style={styles.valueCell}>{'N/D'}</td>
                <td style={styles.labelCell}>E-mail:</td>
                <td style={styles.valueCell}>{userData?.email ?? "N/D"}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Nova tabela para itens */}
        <div style={styles.itemTable}>
          <table style={styles.table}>
            <thead>
              <tr style={styles.tr}>
                <th style={styles.itemHeader1}>Num. Operação</th>
                <th style={styles.itemHeader}>Descrição</th>
                <th style={styles.itemHeader}>Valor</th>
                <th style={styles.itemHeader}>Moeda</th>
                <th style={styles.itemHeader2}>Valor</th>
                {/* <th style={styles.itemHeader1}>Num. Operação</th>
                <th style={styles.itemHeader}>Banco</th>
                <th style={styles.itemHeader}>Número Conta</th>
                <th style={styles.itemHeader}>Moeda</th>
                <th style={styles.itemHeader2}>Valor</th> */}
              </tr>
            </thead>
            <tbody>
              {transactionData.transactions && transactionData.transactions.length > 0 ?
                transactionData.transactions.map((transaction, index) => {
                  return <tr style={styles.tr}>
                    <td style={styles.itemCell}>{index + 1}</td>
                    <td style={styles.itemCell}>{(monthsTranslation[studentDebtData?.month as keyof typeof monthsTranslation] || studentDebtData?.month) ?? "N/D"}</td>
                    <td style={styles.itemCell}>{transaction?.amountPaid}</td>
                    <td style={styles.itemCell}>MZN</td>
                    <td style={styles.itemCell}>{transaction?.amountPaid}</td>
                  </tr>
                })
                : <></>
              }
            </tbody>
          </table>
        </div>

        <div style={styles.paymentInfoSection}>
          <div style={styles.paymentTable701}></div>
          <div style={{ width: '40%', marginTop: '18px' }}>
            Data de Pagamento: {studentDebtData?.paidDate ? formatDateForInput(studentDebtData.paidDate) : currentDate}
          </div>
        </div>
        <div style={styles.paymentInfoSection}>
          <div style={styles.paymentTable701}></div>
          <div style={styles.paymentTable301}>
            <table style={styles.table}>

              <tbody>
                <tr>
                  <td style={styles.labelCell}>Total:</td>
                  <td style={styles.valueCell1}>{total}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div style={{ textAlign: "left", marginTop: "10px", fontSize: "smaller", fontWeight: "bold" }}>
          <p>
            Descrição: {studentDebtData?.description ?? "N/D"}
          </p>
        </div>

        <div style={{ textAlign: "left", marginTop: "40px", fontSize: "smaller" }}>
          <p>
            Documento Processsado por Computador<br />
            Impresso em  {currentDate}, por {loggedUserData?.Fullname}<br />
            <br /><br />
          </p>
        </div>

        <footer style={{ textAlign: "center", marginTop: "240px", padding: "10px 0", fontSize: "7px" }}>
          <p>
            {IES.NAME}<br />
            {IES.PHONE_NUMBER} - {IES.EMAIL}<br />
            {IES.NAME} <br />
            {IES.COUNTRY}
          </p>
        </footer>
      </div>
    </PdfPreviewContent>
  );
};
